module.exports = __webpack_public_path__ + "img/4.acdbbb74.png";